import { render, staticRenderFns } from "./d-leaderboard-feed-entry.vue?vue&type=template&id=1c365b78&scoped=true&"
import script from "./d-leaderboard-feed-entry.vue?vue&type=script&lang=js&"
export * from "./d-leaderboard-feed-entry.vue?vue&type=script&lang=js&"
import style0 from "./d-leaderboard-feed-entry.vue?vue&type=style&index=0&id=1c365b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c365b78",
  null
  
)

export default component.exports